import { render, staticRenderFns } from "./MostExam.vue?vue&type=template&id=ec8ea7e2&scoped=true"
import script from "./MostExam.vue?vue&type=script&lang=js"
export * from "./MostExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8ea7e2",
  null
  
)

export default component.exports